import { render, staticRenderFns } from "./facturaModal.vue?vue&type=template&id=68d6fd60&"
import script from "./facturaModal.vue?vue&type=script&lang=js&"
export * from "./facturaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QIcon,QSelect,QMarkupTable,QTr,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QIcon,QSelect,QMarkupTable,QTr,QTd,QBtn,QTooltip})
